import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { APP_CONFIG, BaseAppConfig } from './app.config';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import {environment} from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {Address} from '../models/address.models';
import {User} from '../models/user.models';
import {Booking} from '../models/booking.models';
import {MyNotification} from '../models/notification.models';
import {InvoiceLine} from '../models/invoiceLine.models';
import {Service} from '../models/service.models';
import {SubService} from '../models/subService.models';
import {History} from '../models/history.models';
import {Plan} from '../models/plan.models';
import {Message} from '../models/message.models';
import {Setting} from '../models/settings.models';
import {Invoice} from '../models/invoice.models';
import {Auth} from '../models/auth.models';
import {Rating} from '../models/rating.models';
import {Quotation} from '../models/quotation.models';
import {QuotationLine} from '../models/quotationLine';
import {Signature} from '../models/signature.models';
import {Provider} from '../models/provider.models';
import {Online} from '../providers/online.service';
import {Functions} from '../utils/utils-functions';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {AngularFireModule} from '@angular/fire';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import {AngularFirestoreModule} from '@angular/fire/firestore';
import {AngularFireAuthModule} from '@angular/fire/auth';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { File } from '@ionic-native/file/ngx';
import { Camera } from '@ionic-native/camera/ngx';
import {FilePath} from '@ionic-native/file-path/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Facebook } from '@ionic-native/facebook/ngx';
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';
import { SignInWithApple } from "@ionic-native/sign-in-with-apple/ngx";
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions,@typescript-eslint/naming-convention
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    BrowserModule, IonicModule.forRoot(), AppRoutingModule,
    HttpClientModule,
    TranslateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    Address, User, Booking, MyNotification, InvoiceLine,
    Service, SubService, History, Plan, Message, Setting, Invoice,
    Online, Auth, Rating, Quotation, QuotationLine, Functions,
    Signature, Provider, SplashScreen, StatusBar, Camera , File,
    FilePath, Geolocation, OneSignal, LocationAccuracy, AndroidPermissions,
    Facebook, GooglePlus, InAppPurchase2, SignInWithApple, FirebaseX,
    { provide: APP_CONFIG, useValue: BaseAppConfig },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
